import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "localityFilled"
const LocalityFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M13.125 1.5C13.953 1.5 14.625 2.172 14.625 3V22.5H2.625V3C2.625 2.172 3.297 1.5 4.125 1.5zM6.75 17.25C6.336 17.25 6 17.586 6 18V21H11.25V18C11.25 17.586 10.914 17.25 10.5 17.25zM6 12.75V14.25H7.5V12.75zM9.75 12.75V14.25H11.25V12.75zM6 9V10.5H7.5V9zM9.75 9V10.5H11.25V9zM6 5.25V6.75H7.5V5.25zM9.75 5.25V6.75H11.25V5.25zM20.25 9.75C21.078 9.75 21.75 10.422 21.75 11.25V21.75Q21.75 21.804 21.741 21.857 21.74 21.88 21.735 21.9 21.717 21.986 21.68 22.064 21.657 22.114 21.628 22.16L21.612 22.18Q21.578 22.231 21.537 22.272L21.522 22.287Q21.504 22.305 21.483 22.322L21.472 22.332 21.434 22.361 21.41 22.376Q21.39 22.391 21.368 22.402L21.352 22.412 21.314 22.43 21.286 22.444 21.233 22.463Q21.227 22.463 21.222 22.466 21.152 22.488 21.077 22.496L21 22.5H16.125V9.75zM18 17.25V18.75H19.5V17.25zM18 13.5V15H19.5V13.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LocalityFilledIcon
